import { pendingLayerIndex, sortPaintedLayers } from '../shared/paintOrder';
import type { Draft, Placement } from '../shared/types';

/** One flat list lets React move an editable canvas without remounting it.
 * Pending entries at the same gap keep their input order, deterministically. */
export function panelLayerStack<T>(placements: readonly Placement[], pending: readonly { position: Pick<Draft, 'paintOrder' | 'belowPlacementId'>; value: T }[], render: (placement: Placement) => T): T[] {
  const saved = sortPaintedLayers(placements).filter(layer=>!layer.removed);
  const gaps: T[][] = Array.from({ length: saved.length + 1 }, () => []);
  for (const entry of pending) gaps[pendingLayerIndex(placements, entry.position)].push(entry.value);
  const stack: T[] = [];
  for (let i = 0; i <= saved.length; i++) { stack.push(...gaps[i]); if (i < saved.length) stack.push(render(saved[i])); }
  return stack;
}
